import { useChainId } from 'wagmi'
import { useReferrers } from '@/hooks/api/useReferrers'

export type { ReferrerRow, ReferrerStatus } from '@/hooks/api/useReferrers'

// The referrer roster on the connected chain: the service's referrer set with
// live per-row reads (see useReferrers).
export function useReferralRoster() {
    return useReferrers(useChainId())
}
